import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 21"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#283570",
      d: "M8 10.5q.825 0 1.412-.588Q10 9.326 10 8.5q0-.824-.588-1.412A1.93 1.93 0 0 0 8 6.5q-.824 0-1.412.588A1.93 1.93 0 0 0 6 8.5q0 .825.588 1.412.587.588 1.412.588m0 7.35q3.05-2.8 4.525-5.088Q14 10.476 14 8.7q0-2.725-1.738-4.462Q10.526 2.5 8 2.5T3.738 4.237Q2 5.976 2 8.7q0 1.775 1.475 4.063Q4.95 15.048 8 17.85m0 2.65q-4.024-3.425-6.012-6.363Q0 11.2 0 8.7q0-3.75 2.413-5.975T8 .5t5.588 2.225T16 8.7q0 2.5-1.988 5.438T8 20.5"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "locationOutline"}) } }